import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/instellingen",
    name: "settings.index",
    component: () => import("@/modules/settings/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
